// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon21(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M11.52 15.06h3.204a.333.333 0 1 0 0-.667h-3.203a.333.333 0 1 0 0 .666ZM11.52 16.78h3.204a.333.333 0 1 0 0-.667h-3.203a.333.333 0 1 0 0 .667ZM11.52 18.5h3.204a.333.333 0 0 0 0-.666h-3.203a.333.333 0 1 0 0 .667ZM11.52 20.22h1.308a.333.333 0 1 0 0-.667H11.52a.333.333 0 0 0 0 .666ZM18.263 24.207h-4a.333.333 0 1 0 0 .667h4a.333.333 0 1 0 0-.667ZM10.332 29.556a3.267 3.267 0 0 1-2.77-1.52.333.333 0 1 0-.563.357 3.934 3.934 0 0 0 3.333 1.83.333.333 0 1 0 0-.667ZM19.82 19.36a2.024 2.024 0 1 0 0-4.048 2.024 2.024 0 0 0 0 4.047Zm0-3.38a1.357 1.357 0 1 1 0 2.713 1.357 1.357 0 0 1 0-2.714Z" />
        <path d="M26.02 26.103h-2.31V12.027a4.637 4.637 0 0 0-1.816-3.667l-2.777-2.113v-1.16a.58.58 0 0 0 .55-.577c0-1 .024-1.08-.056-1.253.08-.17.056-.064.056-2.667a.58.58 0 0 0-.563-.59h-5.667a.58.58 0 0 0-.576.577c0 2.623-.02 2.51.056 2.666-.08.17-.056.204-.056 1.254a.58.58 0 0 0 .563.576v1.16l-2.79 2.127a4.666 4.666 0 0 0-1.817 3.667v14.076H6.001a1.254 1.254 0 0 0-1.224 1.564A5.717 5.717 0 0 0 10.761 32c.21.023-.697 0 10.773 0a2.18 2.18 0 0 0 2.177-2.18v-1.24h2.31a1.24 1.24 0 1 0 0-2.477Zm-2.976-5.483h-6.447v-6.567h6.447v6.567Zm0-7.233h-6.78a.333.333 0 0 0-.333.333v7.233a.333.333 0 0 0 .333.334h6.78v1.023H9.484v-9.947h13.56v1.024Zm-13.56 9.59h13.56v3.126H9.484v-3.126Zm4.03-18.557v-.83H19v.83h-5.487Zm0-3.753H19v2.256h-5.487V.667ZM11.04 8.893l2.816-2.146h2.407a.333.333 0 1 0 0-.667h-2.187v-1h4.374v1.333a.333.333 0 0 0 .13.267l2.906 2.213a3.949 3.949 0 0 1 1.537 2.804H9.504a3.95 3.95 0 0 1 1.537-2.804Zm12 20.927a1.514 1.514 0 0 1-1.507 1.513H13a5.687 5.687 0 0 0 2.55-2.753h7.493l-.003 1.24Zm2.976-1.907H15.334a.333.333 0 0 0-.31.214 5.054 5.054 0 0 1-9.607-.62.587.587 0 0 1 .584-.737h20.033a.573.573 0 1 1 0 1.143h-.017Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon21;
